exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".move-left[data-v-d0525e0e]{padding-left:0}.col-width[data-v-d0525e0e]{padding-left:3px;padding-right:3px}", ""]);

// exports
